(function () {
	const acc = document.getElementsByClassName('accordion');

	for (let i = 0; i < acc.length; i++) {
		acc[i].addEventListener('click', function () {
			const panel = this.nextElementSibling;
			const wasActive = this.classList.contains('active');

			// Close all inner accordions
			for (let j = 0; j < acc.length; j++) {
				acc[j].classList.remove('active');
				acc[j].nextElementSibling.style.maxHeight = null;
			}

			// Toggle clicked panel
			if (!wasActive) {
				this.classList.add('active');
				panel.style.maxHeight = panel.scrollHeight + 'px';
			}

			// Wait for the CSS transition to fully complete, then recalc
			panel.addEventListener('transitionend', function handler(e) {
				if (e.propertyName !== 'max-height') return;
				panel.removeEventListener('transitionend', handler);
				if (typeof window._recalcParents === 'function') {
					window._recalcParents(panel);
				}
			});
		});
	}
})();